import { BottomNavigationTabsHome, TabsParent } from "@swiggy-private/dls-web-core/dist/components/BottomNavigation";

export const PIN_AUTHENTICATED_TABS: TabsParent[] = [BottomNavigationTabsHome.SEARCH];

export const OBJECT_NAMES = {
    IMPRESSION_TAB: "impression-bottom-nav",
    CLICK_TAB: "click-bottom-nav",
};

export const BOTTOM_NAV_VALUE_KEY = "bottom-nav-value";
